var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomThemeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30502",
    "data-name": "Group 30502",
    transform: "translate(10709 -17341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30485",
    "data-name": "Group 30485"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14180",
    "data-name": "Rectangle 14180",
    width: 32,
    height: 32,
    transform: "translate(-10709 17341)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "target",
    transform: "translate(-10703.45 17346.551)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1009",
    "data-name": "Ellipse 1009",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2.45 2.451)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1010",
    "data-name": "Ellipse 1010",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(5.45 5.451)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1011",
    "data-name": "Ellipse 1011",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(8.45 8.451)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "crosshair_1_",
    "data-name": "crosshair (1)",
    transform: "translate(-10702.941 17347.059)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1012",
    "data-name": "Ellipse 1012",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1.941 1.941)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1031",
    "data-name": "Line 1031",
    x1: 3,
    transform: "translate(14.941 9.941)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1032",
    "data-name": "Line 1032",
    x1: 3,
    transform: "translate(1.941 9.941)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1033",
    "data-name": "Line 1033",
    y1: 3,
    transform: "translate(9.941 1.941)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    y1: 3,
    transform: "translate(9.941 14.941)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomThemeActive);
export default __webpack_public_path__ + "static/media/customThemeActive.ce435a7a.svg";
export { ForwardRef as ReactComponent };